import { MobileMessageDialogContent } from "./mobile-message-dialog-content";
import { MobileMessageDialogWrapper } from "./mobile-message-dialog-wrapper";

export const MobileMessageDialog = () => {
  return (
    <MobileMessageDialogWrapper>
      <MobileMessageDialogContent />
    </MobileMessageDialogWrapper>
  );
};
